module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "post-img-about post-container-about"
  }, [_c('img', {
    staticClass: "img-about",
    attrs: {
      "src": require("../../assets/efim.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "post-text"
  }, [_c('h1', [_vm._v("Efim Rozovsky")]), _vm._v(" "), _c('p', [_vm._v("\n          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam eaque illo quibusdam, consectetur eos facere cum perspiciatis\n          aperiam voluptas inventore nesciunt, assumenda nemo, maiores, deserunt ratione voluptatum sint expedita\n          labore! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam eaque illo quibusdam, consectetur eos facere cum perspiciatis\n          aperiam voluptas inventore nesciunt, assumenda nemo, maiores, deserunt ratione voluptatum sint expedita\n          labore!\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "post-img-about post-container-about"
  }, [_c('img', {
    staticClass: "img-about",
    attrs: {
      "src": require("../../assets/lora.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "post-text"
  }, [_c('h1', [_vm._v("Lora Arshavski")]), _vm._v(" "), _c('p', [_vm._v("\n          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam eaque illo quibusdam, consectetur eos facere cum perspiciatis\n          aperiam voluptas inventore nesciunt, assumenda nemo, maiores, deserunt ratione voluptatum sint expedita\n          labore! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam eaque illo quibusdam, consectetur eos facere cum perspiciatis\n          aperiam voluptas inventore nesciunt, assumenda nemo, maiores, deserunt ratione voluptatum sint expedita\n          labore!\n      ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f3577b98","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/about.vue
// module id = 298
// module chunks = 1